// BDSJEA-194: mapa unico de severidad de las alertas de scoring.
// El backend entrega "CRITICAL", "WARNING", "INFO" o null y ya ordena las
// alertas por gravedad: el front NO reordena. Se aceptan sinonimos de lectura
// por tolerancia con scorings viejos (ALTA/CRITICA, MEDIA, BAJA).

export const SEVERIDAD_ALERTA = {
  CRITICAL: { color: "danger", etiqueta: "Crítica" },
  WARNING: { color: "warning", etiqueta: "Advertencia" },
  INFO: { color: "info", etiqueta: "Informativa" },
}

export const SINONIMOS_SEVERIDAD = {
  CRITICA: "CRITICAL",
  ALTA: "CRITICAL",
  MEDIA: "WARNING",
  BAJA: "INFO",
}

const SIN_CLASIFICAR = { color: "secondary", etiqueta: "Sin clasificar" }

/**
 * Devuelve { clave, color, etiqueta } para una severidad cualquiera.
 * Nula, vacia o desconocida => neutro "Sin clasificar" (clave null).
 */
export const infoSeveridad = valor => {
  const texto = typeof valor === "string" ? valor.trim().toUpperCase() : ""
  const clave = SEVERIDAD_ALERTA[texto] ? texto : SINONIMOS_SEVERIDAD[texto]
  if (!clave) return { clave: null, ...SIN_CLASIFICAR }
  return { clave, ...SEVERIDAD_ALERTA[clave] }
}
